export default __webpack_public_path__ + "static/media/G0380-Asthma_algorithm.1710502980000.cd8a91c9.jpg";